// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1rWl2","alertIcon":"ConfirmModal_alertIcon__1rY6S"};